/**
 * This file exixts in order to export the history instance
 * that can be used directly to push new paths, i.e.:
 * history.push('/login')
 */
import { createBrowserHistory } from 'history'
const history = createBrowserHistory()
export default history
